/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'st-certificate ': {
    width: 24,
    height: 24,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M8 8h16v2H8V8zm10 22.8l2-1 2 1V26h-4zM24 20a4 4 0 0 1-8 0 4 4 0 0 1 8 0z"/><path pid="1" d="M30 2H2v26h14v-3.6c-1.2-1-2-2.6-2-4.4 0-3.4 2.6-6 6-6s6 2.6 6 6c0 1.8-.8 3.4-2 4.4V28h6V2zM12 24H6v-2h6v2zm0-4H6v-2h6v2zm0-4H6v-2h6v2zm14-4H6V6h20v6z"/>'
  }
})
